/* eslint-disable @typescript-eslint/naming-convention, import/no-default-export, react/prop-types */
import React from 'react';
import { Route as BRoute } from 'react-router';

const Route = ({ path, exact = false, component: Component }) => (
  <BRoute path={path} exact={exact} render={({ match: { params } }) => <Component {...params} />} />
);

export default Route;
